import { ChevronRight } from '@src/components/atoms/icons/chevron-right';
import { TextLink, TextLinkAnchor } from '@src/components/atoms/text-link';
import { TripDateSpan } from '@src/components/common/formatting/trip-date-span';
import { useCmsContent } from '@src/contexts/cms-content-context';
import { useTripListItem } from '@src/contexts/trip-list-item-context';
import { useAnalytics } from '@src/features/analytics/hooks';
import { AnalyticsEvent } from '@src/features/analytics/types';
import { Link } from '@src/i18n/routing';

import { Dates, PastCancelledTripTitle } from '../styles';
import { Card } from './card';
import { ChevronWrapper, StretchedTitleLink } from './styles';

export const PastCanceledTripCard = () => {
  const content = useCmsContent();
  const { trip } = useTripListItem();
  const isPastTrip = ['CheckedOut', 'NoShow'].includes(trip.status);
  const { trackEvent } = useAnalytics();

  const trackBookAgainClick = () => {
    void trackEvent({
      event: AnalyticsEvent.BookAgainClicked,
      properties: {
        source: 'TripsPage/TripPreviewCard',
        property_id: trip.property.id,
      },
    });
  };

  const tripDetailUrl = `/trips/${trip.id}`;
  const invoiceUrl = `/trips/${trip.id}/invoice`;
  const canViewInvoice = isPastTrip && trip.permissions.canAccessInvoice;
  const image = trip.unitGroup.pictures[0]?.responsiveImage;
  return (
    <Card>
      {image && <Card.Image {...image} />}

      <Card.Content>
        <StretchedTitleLink href={tripDetailUrl} prefetch={false}>
          <PastCancelledTripTitle>{trip.property.name}</PastCancelledTripTitle>

          <Dates>
            <TripDateSpan trip={trip} format="short" />
          </Dates>
        </StretchedTitleLink>
        <Card.Actions>
          <TextLink onClick={trackBookAgainClick} href={trip.roomPageUrl}>
            {content.bookAgain}
          </TextLink>
          {canViewInvoice && (
            <TextLinkAnchor as={Link} href={invoiceUrl}>
              {content.viewInvoice}
            </TextLinkAnchor>
          )}
        </Card.Actions>
      </Card.Content>

      <ChevronWrapper>
        <ChevronRight />
      </ChevronWrapper>
    </Card>
  );
};
